import { Stack, Text, ThemeIcon } from "@mantine/core";
import type { LucideIcon } from "lucide-react";
import { PackageOpen } from "lucide-react";
import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({
  icon: Icon = PackageOpen,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <Stack align="center" py="xl" gap="md" role="status">
      <ThemeIcon
        size={64}
        variant="light"
        color="blue"
        radius="xl"
        aria-hidden="true"
      >
        <Icon size={32} />
      </ThemeIcon>
      <Stack align="center" gap="xs">
        <Text fw={500} size="lg">
          {title}
        </Text>
        {description && (
          <Text size="sm" c="dimmed" ta="center" maw={320}>
            {description}
          </Text>
        )}
      </Stack>
      {action}
    </Stack>
  );
}
